import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Card, Skeleton, Space, Tabs } from "antd";
import { sortBy, groupBy } from "lodash";
import "./HotelDetails.css";

const { TabPane } = Tabs;

const preProcessHotelList = (hotels) => {
  let returnArray = [];
  if (Array.isArray(hotels)) {
    const flattenedArray = hotels.map((hotel) => ({
      _id: hotel._id,
      hotel_name: hotel.hotel_name,
      hotel_code: hotel.hotel_code,
      primary_hmg_id: hotel.primary_hmg_id?.hmg_id?._id,
      primary_hmg_name: hotel.primary_hmg_id?.hmg_id?.hmg_name,
    }));
    returnArray = groupBy(
      sortBy(flattenedArray, ["primary_hmg_name", "hotel_name"]),
      "primary_hmg_id",
    );
  }
  return returnArray;
};

const HotelDetails = (props) => {
  const { userDetails, cardTitleStyle, hasEditAccess, isLoading } = props;
  const preProcessedHotelList = preProcessHotelList(userDetails?.hotels);

  return (
    <Card
      title={
        <Space size={120}>
          <span style={cardTitleStyle}>Hotel Management Group</span>
          <span>
            <b>Hotel</b>
          </span>
        </Space>
      }
      bordered={false}
      extra={
        hasEditAccess && userDetails?._id ? (
          <Link to={`/user-create/${userDetails?._id}?step=hotel`}>Edit</Link>
        ) : null
      }
    >
      {isLoading && <Skeleton active title={false} paragraph={{ rows: 4 }} />}
      {!isLoading && Object.keys(preProcessedHotelList).length > 0 ? (
        <div className="customizedClass">
          <Tabs
            defaultActiveKey={Object.keys(preProcessedHotelList)[0]}
            tabPosition="left"
            className={
              Object.keys(preProcessedHotelList).length > 6 && "hmg_tab-pane"
            }
          >
            {Object.keys(preProcessedHotelList).map((hmgObjKey) => (
              <TabPane
                tab={(
                  <span style={{ minWidth: "300px" }}>
                    {preProcessedHotelList[hmgObjKey][0].primary_hmg_name}
                  </span>
                )}
                key={hmgObjKey}
                className={
                  preProcessedHotelList[hmgObjKey]?.length > 15 &&
                  "hotelDetails_tab-pane"
                }
              >
                {preProcessedHotelList[hmgObjKey].map((hotel) => (
                  <h4 key={hotel._id}>
                    {process.env?.REACT_APP_PLATFORM_TYPE === "GENERIC"
                      ? hotel.hotel_name
                      : `${hotel.hotel_code} - ${hotel.hotel_name}`}
                  </h4>
                ))}
              </TabPane>
            ))}
          </Tabs>
        </div>
      ) : null}
    </Card>
  );
};

HotelDetails.defaultProps = {
  isLoading: true,
};

HotelDetails.propTypes = {};

export default HotelDetails;
